import gql from "graphql-tag";
import graphqlClient from "../../../apollo";

class TradingStrategyProvider {
  getTradingStrategy() {
    return graphqlClient.query({
      query: gql`
        query {
          tradingStrategy {
            data
          }
        }
      `,
      fetchPolicy: "no-cache",
    });
  }
}

export default new TradingStrategyProvider();
